import React from 'react';
import { DollarSign, CheckSquare, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BottomBar: React.FC = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'add-expense',
      title: 'Add Expense',
      icon: DollarSign,
      action: () => navigate('/finance/expenses/add'),
      color: 'bg-red-500 hover:bg-red-600'
    },
    {
      id: 'add-task',
      title: 'Add Task',
      icon: CheckSquare,
      action: () => navigate('/todo?add=1'),
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      id: 'add-health',
      title: 'Add Health',
      icon: Heart,
      action: () => navigate('/health/weight/add'),
      color: 'bg-green-500 hover:bg-green-600'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-theme-primary border-t border-theme-primary z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-around items-center h-16">
          {quickActions.map((action) => {
            const IconComponent = action.icon;
            return (
              <button
                key={action.id}
                onClick={action.action}
                className="flex flex-col items-center justify-center flex-1 py-2 transition-colors rounded-md hover:bg-white/10 dark:hover:bg-white/10 dark:active:bg-white/20 focus:outline-none"
                title={action.title}
              >
                <IconComponent className="h-6 w-6 text-theme-secondary" />
                <span className="text-xs mt-1 font-medium">{action.title}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomBar; 